import { render, staticRenderFns } from "./CreateEmailTemplateBtn.vue?vue&type=template&id=58d33dde&"
import script from "./CreateEmailTemplateBtn.vue?vue&type=script&lang=js&"
export * from "./CreateEmailTemplateBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports